import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { UserImage } from '@/components/ui/Image/UserImage';
const sizes = {
    lg: 'w-[50px] h-[50px] text-[50px] leading-none',
    md: 'w-[40px] h-[40px] text-[40px] leading-none',
    sm: 'w-[30px] h-[30px] text-[30px] leading-none',
    none: '', // eslint-disable-line sort-keys-fix/sort-keys-fix
};
export const Avatar = (props) => {
    const { alt = 'avatar', className = '', isBlur, isGrayScale, size = 'md', src = '', webpSrc, } = props;
    return (_jsx("div", Object.assign({ className: clsx(sizes[size], 'flex items-center justify-center', 'overflow-hidden', 'rounded-full', 'bg-gray-400', className) }, { children: _jsx(UserImage, { alt: alt, isBlur: isBlur, isGrayScale: isGrayScale, objectPosition: 'cover', pictureClassName: 'w-full h-full', src: src || '', webpSrc: webpSrc }) })));
};
export const avatarSizes = sizes;
